const featuredCollectionLinks = document.querySelectorAll('.featured-collection-link');

async function fetchCollection(e) {
  const collectionHandle = e.target.dataset.collectionHandle;

  featuredCollectionLinks.forEach((link) => {
    link.classList.remove('active');
  });

  e.target.classList.add('active');

  const parentFeaturedCollection = e.target.closest('.featured-collection');
  const swiperWrapper = parentFeaturedCollection.querySelector('.swiper-wrapper');
  const shopAllButton = parentFeaturedCollection.querySelector(`.featured-collection-shop-all-button`);

  shopAllButton.setAttribute('href', `/collections/${collectionHandle}`);

  swiperWrapper.style.opacity = 0.5;

  const collection = await fetch(`/collections/${collectionHandle}?view=featured`);
  const collectionHTML = await collection.text();

  swiperWrapper.innerHTML = collectionHTML;
  setTimeout(() => {
    swiperWrapper.style.opacity = 1;
  }, 300);
}

for (const link of featuredCollectionLinks) {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    fetchCollection(e);
  });
}
